import FeatureGates from "@atlassian/feature-gate-js-client";
import { MeResponse, ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";
import { IntercomProvider } from "@/libraries/intercom/src";

import { AppPricingData } from "../../contentful";
import { ConfluenceSoftwarePageTemplate } from "../../templates/confluence-software-page/src";

export type ConfluenceSoftwarePageProps = {
    pricing?: AppPricingData;
    availableProducts: AvailableProductsResponse | null;
    userProfile: MeResponse | null;
};

export const ConfluenceSoftwarePage = (props: ConfluenceSoftwarePageProps) => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-confluence"
    );

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            <CrossFlowTouchpointProvider
                screenName="wacConfluenceProductTourPage"
                productKeys={[ProductKeys.CONFLUENCE]}
            >
                <ConfluenceSoftwarePageTemplate
                    pricing={props.pricing}
                    availableProducts={props.availableProducts}
                    userProfile={props.userProfile}
                />
            </CrossFlowTouchpointProvider>
        </IntercomProvider>
    );
};
